export const RightArrowIcon = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.41091 3.57741C9.73634 3.25197 10.264 3.25197 10.5894 3.57741L16.4228 9.41074C16.7482 9.73618 16.7482 10.2638 16.4228 10.5893L10.5894 16.4226C10.264 16.748 9.73634 16.748 9.41091 16.4226C9.08547 16.0972 9.08547 15.5695 9.41091 15.2441L13.8217 10.8333H4.16683C3.70659 10.8333 3.3335 10.4602 3.3335 10C3.3335 9.53976 3.70659 9.16667 4.16683 9.16667H13.8217L9.41091 4.75592C9.08547 4.43049 9.08547 3.90285 9.41091 3.57741Z"
				fill="currentColor"
			/>
		</svg>
	)
}
